const projectSettingsPath = '/project-settings';
export const missingProjectRedirectPath = '/execution-runs';
export const missingProjectRedirectMessage = 'Redirecting to execution runs...';
export const projectCsvMappingAnchorId = 'xlsx-csv-mapping';
export const projectExecutionRunThresholdsAnchorId = 'execution-run-metric-thresholds';
const csvMappingHash = `#${projectCsvMappingAnchorId}`;
const executionRunThresholdsHash = `#${projectExecutionRunThresholdsAnchorId}`;
const projectIdParam = 'projectId';

export const buildProjectSettingsHref = (projectId: string): string => {
  const searchParams = new URLSearchParams({ [projectIdParam]: projectId });
  return `${projectSettingsPath}?${searchParams.toString()}`;
};

export const buildProjectCsvMappingSettingsHref = (projectId: string): string => {
  return `${buildProjectSettingsHref(projectId)}${csvMappingHash}`;
};

export const buildProjectExecutionRunThresholdsSettingsHref = (projectId: string): string => {
  return `${buildProjectSettingsHref(projectId)}${executionRunThresholdsHash}`;
};

export const resolveProjectSettingsProjectId = (search: string): string | null => {
  const searchParams = new URLSearchParams(search);
  const projectId = searchParams.get(projectIdParam)?.trim() ?? '';
  return projectId.length > 0 ? projectId : null;
};

export const resolveProjectSettingsTabFromHash = (hash: string): 'test' | 'operations' | null => {
  if (hash === `#${projectCsvMappingAnchorId}`) {
    return 'test';
  }
  if (hash === `#${projectExecutionRunThresholdsAnchorId}`) {
    return 'test';
  }
  return null;
};
